const { getElements } = window.BAO.Utils

class WishlistPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.populateLists = this.populateLists.bind(this)
    this.handleWishlistChange = this.handleWishlistChange.bind(this)
    this.setupWishlist = this.setupWishlist.bind(this)

    this.handleRemoveItem = this.handleRemoveItem.bind(this)

    this.getCurrentWishlistDetails = this.getCurrentWishlistDetails.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    this.handleAddAllItemsAndRender =
      this.handleAddAllItemsAndRender.bind(this)

    this.handleWishlistItemSelectChange =
      this.handleWishlistItemSelectChange.bind(this)

    this.handleAddSingleItemAddToCart =
      this.handleAddSingleItemAddToCart.bind(this)

    this.listeners.add(document, 'click', this.handleWishlistChange)
    this.listeners.add(document, 'click', this.handleRemoveItem)
    this.listeners.add(document, 'click', this.handleAddAllItemsAndRender)

    this.listeners.add(document, 'change', this.handleWishlistItemSelectChange)
    this.listeners.add(document, 'click', this.handleAddSingleItemAddToCart)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    })
  }

  populateLists (lists) {
    this.els.delete.element.setAttribute('aria-hidden', lists.length < 2)

    this.els.wishlists.element.innerHTML = ''

    if (lists.length > 0) {
      lists.forEach((list, index) => {
        if (index === 0) {
          this.els['current-wishlist-text'].element.setAttribute(
            'data-wishlist-id',
            list.lid,
          )
        }

        this.els.wishlists.element.innerHTML += this.createHomeElement(
          list,
          index,
        )

        this.externalEls.lists.element.innerHTML += this.createDrawerElement(
          list,
          index,
        )
      })

      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', false)
      this.els['page-empty'].element.setAttribute('aria-hidden', true)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', true)
      this.els['page-empty'].element.setAttribute('aria-hidden', false)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    }
  }

  createHomeElement (list, index) {
    let cardImages = ''

    if (list.cnt > 0) {
      cardImages = '<div class="wsh-Card_Images">'
      list.listcontents.slice(0, 3).forEach((listItem) => {
        cardImages += `<img class="wsh-Card_Image" src="${listItem.iu}" alt="${listItem.dt}">`
      })

      cardImages += '</div>'
    }

    return `<div class="wsh-Card">
      <button
        type="button"
        class="wsh-Card_Title fz-18_150"
        data-wishlist-page-el="wishlist-change-trigger"
        data-wishlist-id="${list.lid}"
      >
        ${list.lname}
      </button>
      <p class="wsh-Card_Text fz-14_175">${list.cnt} ${
        list.cnt === 1
          ? window.theme.wishlist.item
          : window.theme.wishlist.items
      }</p>

      ${cardImages}

      <div class="wsh-Card_Buttons">
        <button
          type="button"
          class="wsh-Card_Button btn-Button btn-Button-primary"
          data-wishlist-page-el="wishlist-change-trigger"
          data-wishlist-id="${list.lid}"
        >
          ${window.theme.wishlist.viewWishlist}
        </button>
      </div>
    </div>`
  }

  createDrawerElement (list, index) {
    return `<li class="wsh-Drawer_Item">
      <button
        type="button"
        class="wsh-Drawer_Button btn-Button btn-Button-primary"
        data-wishlist-page-el="wishlist-change-trigger"
        data-wishlist-id="${list.lid}"
      >
        ${list.lname} (${list.cnt})
      </button>
    </li>`
  }

  handleWishlistChange (event) {
    const trigger = event.target.closest(
      '[data-wishlist-page-el="wishlist-change-trigger"]',
    )

    if (!trigger) return

    this.els['current-wishlist'].element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )

    this.els['page-home'].element.setAttribute('aria-hidden', true)

    this.getCurrentWishlistDetails()
  }

  getCurrentWishlistDetails () {
    const listConfig = {
      lid: this.els['current-wishlist'].element.dataset.wishlistId,
    }

    window._swat.fetchListDetails(
      listConfig,
      this.setupWishlist,
      this.wishlistError,
    )
  }

  async setupWishlist (wishlist) {
    this.els['current-wishlist-text'].element.textContent =
      `${wishlist.list.lname} (${wishlist.list.cnt})`

    this.els['current-wishlist-count'].element.textContent =
      `${wishlist.list.cnt}`

    this.els.share.element.setAttribute('data-wishlist-id', wishlist.list.lid)
    this.els.delete.element.setAttribute('data-wishlist-id', wishlist.list.lid)

    getElements('[data-wishlist-page-el="wishlist-change-trigger"]').forEach(
      (el) => {
        el.setAttribute(
          'aria-current',
          el.dataset.wishlistId === wishlist.list.lid,
        )
      },
    )

    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els.products.element.innerHTML = productCardHTML

    if (wishlist.list.cnt > 0) {
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['panel-empty'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['panel-empty'].element.setAttribute('aria-hidden', false)
    }

    setTimeout(() => {
      window.drawers.activeDrawerKey = ''
    }, 450)

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', true)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', false)
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    return window.BAO.sectionRenderer
      .fetchSingle('wishlist-product-card', product.du)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          const itemClasses =
            (index + 1) % 2
              ? 'wsh-Page_Item wsh-Page_Item-left'
              : 'wsh-Page_Item'

          if (myself.querySelector('.prd-Card_WishlistQuickForm')) {
            myself
              .querySelector('.prd-Card_WishlistQuickForm')
              .setAttribute('aria-hidden', false)
          }

          if (
            myself.querySelector('[data-wishlist-quickbuy-action="colours"]')
          ) {
            myself
              .querySelector('[data-wishlist-quickbuy-action="colours"]')
              .setAttribute('aria-hidden', true)
          }

          const mobileQuickbuy = myself.querySelector(
            '[data-wishlist-quickbuy-action="mobile-quickbuy"]',
          )
          if (mobileQuickbuy) {
            mobileQuickbuy.setAttribute('aria-hidden', true)
          }

          if (
            myself.querySelector(
              '[data-wishlist-quickbuy-action="desktop-quickbuy"]',
            )
          ) {
            myself
              .querySelector(
                '[data-wishlist-quickbuy-action="desktop-quickbuy"]',
              )
              .setAttribute('aria-hidden', true)
          }

          if (myself.querySelector('[data-wishlist-quickbuy-action="title"]')) {
            myself
              .querySelector('[data-wishlist-quickbuy-action="title"]')
              .classList.add('prd-Card_Info-wishlist')
          }

          if (
            myself.querySelector('[data-wishlist-quickbuy-action="details"]')
          ) {
            myself
              .querySelector('[data-wishlist-quickbuy-action="details"]')
              .classList.add('prd-Card_Details-wishlist')
          }

          if (
            myself.querySelector('[data-wishlist-quickbuy-action="container"]')
          ) {
            myself
              .querySelector('[data-wishlist-quickbuy-action="container"]')
              .classList.add('prd-Card_QuickBuy-wishlist')
          }

          if (
            myself.querySelector('[data-wishlist-quickbuy-action="trigger"]')
          ) {
            myself
              .querySelector('[data-wishlist-quickbuy-action="trigger"]')
              .classList.add('prd-Card_Button-wishlist')
          }

          return `<div class="${itemClasses}" data-wishlist-page-el="product-item" data-variant-id="${
            product.epi
          }">${myself.outerHTML.replace(
            'data-wishlist-page-el="remove"',
            `data-wishlist-page-el="remove" data-product-id="${product.empi}" data-variant-id="${product.epi}" data-product-url="${product.du}"`,
          )}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  handleRemoveItem (event) {
    const trigger = event.target.closest('[data-wishlist-page-el="remove"]')

    if (!trigger) return

    const lid = this.els['current-wishlist'].element.dataset.wishlistId

    const product = {
      epi: trigger.dataset.variantId,
      empi: trigger.dataset.productId,
      du: trigger.dataset.productUrl,
    }

    window._swat.deleteFromList(
      lid,
      product,
      this.getCurrentWishlistDetails,
      this.wishlistError,
    )
  }

  async handleAddSingleItemAddToCart (event) {
    const trigger = event.target.closest(
      '[data-wishlist-quickbuy-action="trigger"]',
    )

    // Ensure the event is triggered by the "Add Item" button
    if (!trigger) return

    // get the product variant ID
    const productVariantID = trigger.getAttribute('data-variant-id')

    const items = [
      {
        id: productVariantID,
        quantity: 1,
      },
    ]

    if (items.length === 0) {
      // eslint-disable-next-line
      console.log("No items to add.");
      return
    }

    try {
      // Use BaoCart's addItem method
      const state = await window.BAO.Cart.addItem(items, {
        sections: window.BAO.sectionRenderer.pushCartSections.map(
          (s) => s.section,
        ),
        sectionsUrl: window.location.pathname,
      })

      // eslint-disable-next-line
      console.log("Cart updated:", state);

      // Trigger UI re-render for the cart
      if (state && state.sections) {
        this.updateCartUI(state.sections)
      }
    } catch (error) {
      console.error('Error adding items to cart and updating:', error)
    }
  }

  async handleAddAllItemsAndRender (event) {
    const trigger = event.target.closest(
      '[data-wishlist-addallitems-external-el="trigger"]',
    )

    // Ensure the event is triggered by the "Add All Items" button
    if (!trigger) return

    // Locate the panel containing wishlist items
    const gridItems = document.querySelector(
      '[data-wishlist-page-el="panel-list"]',
    )
    if (!gridItems) return

    // Collect only available variant IDs
    const items = Array.from(
      gridItems.querySelectorAll('[data-wishlist-page-el="product-item"]'),
    )
      .filter((el) => {
        // Check if the item is available based on a specific attribute or logic
        const button = el.querySelector(
          '[data-wishlist-quickbuy-action="trigger"]',
        )
        return button && !button.hasAttribute('disabled') // Only include enabled items
      })
      .map((el) => ({
        id: el.dataset.variantId,
        quantity: 1, // Default quantity
      }))

    if (items.length === 0) {
      alert('No available items to add.')
      return
    }

    try {
      // Use BaoCart's addItem method to add items to the cart
      const state = await window.BAO.Cart.addItem(items, {
        sections: window.BAO.sectionRenderer.pushCartSections.map(
          (s) => s.section,
        ),
        sectionsUrl: window.location.pathname,
      })

      // Trigger UI re-render for the cart
      if (state && state.sections) {
        this.updateCartUI(state.sections)
      }
    } catch (error) {
      console.error('Error adding items to cart and updating:', error)
    }
  }

  updateCartUI (sections) {
    Object.keys(sections).forEach((sectionId) => {
      const sectionElement = document.querySelector(`[data-id="${sectionId}"]`)
      if (sectionElement) {
        sectionElement.innerHTML = sections[sectionId]
      }
    })

    // Optionally, trigger any custom events for cart updates
    window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.CHANGED)
  }

  handleWishlistItemSelectChange (event) {
    const trigger = event.target.closest(
      '[data-wishlist-quickbuy-action="select"]',
    )

    if (!trigger) return

    const optionAvailable = trigger.options[trigger.selectedIndex].getAttribute(
      'data-wishlist-quickbuy-variant-available',
    )

    const productVariantID = trigger.value
    const outerParentEl = trigger.closest(
      '[data-wishlist-page-el="product-item"]',
    )
    const parentEl = trigger.closest(
      '[data-wishlist-quickbuy-action="container"]',
    )
    const buttonEl = parentEl.querySelector(
      '[data-wishlist-quickbuy-action="trigger"]',
    )

    outerParentEl.setAttribute('data-variant-id', productVariantID)
    buttonEl.setAttribute('data-variant-id', productVariantID)

    if (optionAvailable === 'true') {
      buttonEl.removeAttribute('disabled')
      buttonEl.textContent = window.theme.strings.addToCart
    } else {
      buttonEl.setAttribute('disabled', true)
      buttonEl.textContent = window.theme.strings.soldOut
    }
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', false)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage)
}
